// flowWindow
import Dialog, { dialogManager } from '../components/Dialog'

export default {
    install(vue, store) {
        // delete confirm 等静态界面
        vue.prototype.$Dialog = Dialog

        // 动态界面管理
        dialogManager.store = store
        vue.prototype.$FlowWindow = dialogManager
    }
}
